import { defineComponent as _defineComponent } from 'vue'
import CallToAction from '@/views/home-view/components/CallToAction.vue';
import SeeOffers from './SeeOffers.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'FlashySection',
  emits: ["seeMoreOffers"],
  setup(__props, { expose: __expose }) {
  __expose();




const __returned__ = { CallToAction, SeeOffers }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})